
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vacation-luggage-storage-and-shipping",
      function () {
        return require("private-next-pages/vacation-luggage-storage-and-shipping/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vacation-luggage-storage-and-shipping"])
      });
    }
  